import React from "react";
import {IndexTemp1Section1} from "./section1/IndexTemp1Section1";

export const IndexTemp1 = () => {
    return (
        <IndexTemp1Section1/>
    );
}
